import React from "react";
import { Users } from "lucide-react";
import { Button } from "@/components/ui/button";

type ActiveTab =
  | "dashboard"
  | "public-ranking"
  | "reports"
  | "withdrawal-requests"
  | "admin-influencers";

interface TabNavigationProps {
  activeTab: ActiveTab;
  userRole: string | null;
  onTabChange: (tab: ActiveTab) => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, userRole, onTabChange }) => {
  const getButtonClasses = (isActive: boolean) => {
    const baseClasses = "flex-1 transition-all duration-300 ease-in-out";
    if (isActive) {
      return `${baseClasses} shadow-lg hover:shadow-xl hover:scale-[1.02]`;
    }
    return `${baseClasses} border-white/10 bg-white/5 text-foreground hover:bg-white/10 hover:border-primary/50 hover:scale-[1.02]`;
  };

  return (
    <div className="border-b border-white/10 bg-black/30 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap gap-3 py-4">
          {userRole === "admin" && (
            <Button
              variant={activeTab === "admin-influencers" ? "default" : "outline"}
              onClick={() => onTabChange("admin-influencers")}
              className={getButtonClasses(activeTab === "admin-influencers")}
            >
              <Users className="w-4 h-4 mr-2" />
              Influencers
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
